import type { TodoType, Action } from "@/types/types";

export function todosReducer(state: TodoType[], action: Action) {
  switch (action.type) {
    case "add":
      return [...state, action.payload];
    case "delete":
      return state.filter((todo) => todo.id !== action.payload.id);
    case "update":
      return state.map((todo) =>
        todo.id === action.payload.id ? action.payload : todo,
      );
    case "dateUpdate": {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return state.map((todo) => {
        const todoDate = new Date(todo.doneBy);
        todoDate.setHours(0, 0, 0, 0);

        if (!todo.done && todoDate < today) {
          console.log("Updating todo date", todo);
          return { ...todo, doneBy: new Date() };
        }
        return todo;
      });
    }
    default:
      throw new Error("Unknown action type");
  }
}
